import Vue from 'vue'
import Vuex from 'vuex'

// Theme for brands
import { theme } from '../native/common/js/theme'
import { theme as momentumTheme } from '../native/momentum/js/theme'
import { theme as sprintTheme } from '../native/sprint/js/theme'
import { theme as otisTheme } from '../native/otis/js/theme'
import { theme as visiTheme } from '../native/otis/js/theme'
import { theme as geeniTheme } from '../native/geeni/js/theme'
import { theme as notionTheme } from '../native/notion/js/theme'
import { theme as nightowlTheme } from '../native/nightowl/js/theme'

// Momentum device instructions
import { ariaOmContent } from './assets/device-models/MO-SE-01'
import { ariaNmContent } from './assets/device-models/MO-SE-SAC01'
import { axelContent } from './assets/device-models/MOCAM-720-01'
import { coriContent } from './assets/device-models/MOCAM-SIG02'
import { knokContent } from './assets/device-models/MOBELL-1080NB01'
import { niroContent } from './assets/device-models/MOGA-001'
import { robbiContent } from './assets/device-models/MOCAM-1080-01'

// Pepper device instructions
import { pepOutletContent } from './assets/device-models/PTO-01'
import { pepPlugContent } from './assets/device-models/PTP-01'
import { pepSwitchContent } from './assets/device-models/PTS-01'
import { loocContent } from './assets/device-models/PDR-01'
import { peaPlugContent } from './assets/device-models/PEA-33'
import { pecCamContent } from './assets/device-models/PEC-33'
import { pehCamContent } from './assets/device-models/PEH-33'
import { pekPlugContent } from './assets/device-models/PEK-33'
import { pemPlugContent } from './assets/device-models/PEM-33'
import { pewBulbContent } from './assets/device-models/PEW-33'
import { pexBulbContent } from './assets/device-models/PEX-33'
import { peyBulbContent } from './assets/device-models/PEY-33'
import { p161Content } from './assets/device-models/P161'
import { p159Content } from './assets/device-models/P159'
import { p158Content } from './assets/device-models/P158'
import { cw051Content } from './assets/device-models/CW051'
import { n102Content } from './assets/device-models/N102'
import { a685Content } from './assets/device-models/A685'
import { ew020Content } from './assets/device-models/EW020'

// Sprint device instructions
import { viewContent } from './assets/device-models/SPRCAM'

// Category instructions
import { airPurifierCategoryContent } from './assets/categories/air_purifier';
import { applianceCategoryContent } from './assets/categories/appliance';
import { bulbCategoryContent } from './assets/categories/bulb';
import { cameraCategoryContent } from './assets/categories/camera';
import { floodlightCategoryContent } from './assets/categories/floodlight';
import { doorbellCategoryContent } from './assets/categories/doorbell';
import { garageCategoryContent } from './assets/categories/garage';
import { humidifierCategoryContent } from './assets/categories/humidifier';
import { lightCategoryContent } from './assets/categories/light';
import { lightStripCategoryContent } from './assets/categories/light_strip';
import { plugCategoryContent } from './assets/categories/plug';
import { petCategoryContent } from './assets/categories/pet';
import { petCameraCategoryContent } from './assets/categories/pet_camera';
import { petFeederCategoryContent } from './assets/categories/pet_feeder';
import { powerStripCategoryContent } from './assets/categories/power_strip';
import { smartScaleCategoryContent } from './assets/categories/smart_scale';
import { sensorCategoryContent } from './assets/categories/sensor';
import { switchCategoryContent } from './assets/categories/switch';
import { thermostatCategoryContent } from './assets/categories/thermostat';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    brands: {
      momentum: {
        name: 'Momentum',
        theme: momentumTheme,
        devices: {
          'MO-SE-01': {
            name: 'Aria OM (MO-SE-01)',
            installationInstructions: ariaOmContent.installationInstructions
          },
          'MO-SE-SAC01': {
            name: 'Aria NM (MO-SE-SAC01)',
            installationInstructions: ariaNmContent.installationInstructions
          },
          'MOBELL-1080NB01': {
            name: 'Knok (MOBELL-1080NB01)',
            installationInstructions: knokContent.installationInstructions
          },
          'MOCAM-720-01': {
            name: 'Axel (MOCAM-720-01)',
            installationInstructions: axelContent.installationInstructions
          },
          'MOCAM-1080-01': {
            name: 'Robbi(MOCAM-1080-01)',
            installationInstructions: robbiContent.installationInstructions
          },
          'MOCAM-SIG02': {
            name: 'Cori (MOCAM-SIG02)',
            installationInstructions: coriContent.installationInstructions
          },
          'MOGA-001': {
            name: 'Niro (MOGA-001)',
            installationInstructions: niroContent.installationInstructions
          }
        }
      },
      pepper: {
        name: 'Pepper',
        theme: theme,
        devices: {
          'MO-SE-01': {
            name: 'Aria OM (MO-SE-01)',
            installationInstructions: ariaOmContent.installationInstructions
          },
          'MO-SE-SAC01': {
            name: 'Aria NM (MO-SE-SAC01)',
            installationInstructions: ariaNmContent.installationInstructions
          },
          'MOBELL-1080NB01': {
            name: 'Knok (MOBELL-1080NB01)',
            installationInstructions: knokContent.installationInstructions
          },
          'MOCAM-720-01': {
            name: 'Axel (MOCAM-720-01)',
            installationInstructions: axelContent.installationInstructions
          },
          'MOCAM-1080-01': {
            name: 'Robbi (MOCAM-1080-01)',
            installationInstructions: robbiContent.installationInstructions
          },
          'MOCAM-SIG02': {
            name: 'Cori (MOCAM-SIG02)',
            installationInstructions: coriContent.installationInstructions
          },
          'MOGA-001': {
            name: 'Niro (MOGA-001)',
            installationInstructions: niroContent.installationInstructions
          },
          'PTO-01': {
            name: 'PowerTech Outlet (PTO-01)',
            installationInstructions: pepOutletContent.installationInstructions
          },
          'PTP-01': {
            name: 'PowerTech Plug (PTP-01)',
            installationInstructions: pepPlugContent.installationInstructions
          },
          'PTS-01': {
            name: 'PowerTech Switch (PTS-01)',
            installationInstructions: pepSwitchContent.installationInstructions
          },
          'PDR-01': {
            name: 'Looc (PDR-01)',
            installationInstructions: loocContent.installationInstructions
          },
          'SPRCAM': {
            name: 'View (SPRCAM)',
            installationInstructions: viewContent.installationInstructions
          },
          'PEA-33': {
            name: 'Leedarson Indoor Smart Camera (PEA-33)',
            installationInstructions: peaPlugContent.installationInstructions
          },
          'PEC-33': {
            name: 'Leedarson Indoor Smart Camera (PEC-33)',
            installationInstructions: pecCamContent.installationInstructions
          },
          'PEH-33': {
            name: 'Notion Camera (PEH-33)',
            installationInstructions: pehCamContent.installationInstructions
          },
          'PEK-33': {
            name: 'Leedarson 15A Plug (PEK-33)',
            installationInstructions: pekPlugContent.installationInstructions
          },
          'PEM-33': {
            name: 'Leedarson 10A Plug (PEM-33)',
            installationInstructions: pemPlugContent.installationInstructions
          },
          'PEW-33': {
            name: 'Leedarson CCT Bulb (PEW-33)',
            installationInstructions: pewBulbContent.installationInstructions
          },
          'PEX-33': {
            name: 'Leedarson Dimmable Bulb (PEX-33)',
            installationInstructions: pexBulbContent.installationInstructions
          },
          'PEY-33': {
            name: 'Leedarson RGBW Bulb (PEY-33)',
            installationInstructions: peyBulbContent.installationInstructions
          },
          'P161': {
            name: 'Whale Indoor Smart Camera (P161)',
            installationInstructions: p161Content.installationInstructions
          },
          'P159': {
            name: 'Whale Indoor Smart Camera (P159)',
            installationInstructions: p159Content.installationInstructions
          },
          'P158': {
            name: 'Whale Indoor Smart Camera (P158)',
            installationInstructions: p158Content.installationInstructions
          },
          'CW051': {
            name: 'Whale Indoor Smart Camera (CW051)',
            installationInstructions: cw051Content.installationInstructions
          },
          'N102': {
            name: 'Notion Doorbell (N102)',
            installationInstructions: n102Content.installationInstructions
          },
          'A685': {
            name: 'Notion Chime (A685)',
            installationInstructions: a685Content.installationInstructions
          },
        },
        categories: {
          air_purifier: {
            name: 'air_purifier',
            installationInstructions: airPurifierCategoryContent.installationInstructions
          },
          appliance: {
            name: 'appliance',
            installationInstructions: applianceCategoryContent.installationInstructions
          },
          camera: {
            name: 'camera',
            installationInstructions: cameraCategoryContent.installationInstructions
          },
          floodlight: {
            name: 'floodlight',
            installationInstructions: floodlightCategoryContent.installationInstructions
          },
          bulb: {
            name: 'bulb',
            installationInstructions: bulbCategoryContent.installationInstructions
          },
          doorbell: {
            name: 'doorbell',
            installationInstructions: doorbellCategoryContent.installationInstructions
          },
          garage_door: {
            name: 'garage_door',
            installationInstructions: garageCategoryContent.installationInstructions
          },
          garage_door_controller: {
            name: 'garage_door_controller',
            installationInstructions: garageCategoryContent.installationInstructions
          },
          light: {
            name: 'light',
            installationInstructions: lightCategoryContent.installationInstructions
          },
          light_strip: {
            name: 'light_strip',
            installationInstructions: lightStripCategoryContent.installationInstructions
          },
          plug: {
            name: 'plug',
            installationInstructions: plugCategoryContent.installationInstructions
          },
          switch: {
            name: 'switch',
            installationInstructions: switchCategoryContent.installationInstructions
          },
          power_strip: {
            name: 'power_strip',
            installationInstructions: powerStripCategoryContent.installationInstructions
          },
          sensor: {
            name: 'sensor',
            installationInstructions: sensorCategoryContent.installationInstructions
          },
          thermostat: {
            name: 'thermostat',
            installationInstructions: thermostatCategoryContent.installationInstructions
          },
          humidifier: {
            name: 'humidifier',
            installationInstructions: humidifierCategoryContent.installationInstructions
          },
          pet: {
            name: 'pet',
            installationInstructions: petCategoryContent.installationInstructions
          },
          pet_camera: {
            name: 'pet_camera',
            installationInstructions: petCameraCategoryContent.installationInstructions
          },
          pet_feeder: {
            name: 'pet_feeder',
            installationInstructions: petFeederCategoryContent.installationInstructions
          },
          smart_scale: {
            name: 'smart_scale',
            installationInstructions: smartScaleCategoryContent.installationInstructions
          },
        }
      },
      sprint: {
        name: 'Sprint',
        theme: sprintTheme,
        devices: {
          'SPRCAM': {
            name: 'View (SPRCAM)',
            installationInstructions: viewContent.installationInstructions
          },
        },
      },
      nightowl: {
        name: 'NightOwl',
        theme: nightowlTheme,
        devices: {
          'SPRCAM': {
            name: 'View (SPRCAM)',
            installationInstructions: viewContent.installationInstructions
          },
          'MI-CW051-999W': {
            name: 'Whale Indoor Smart Camera (CW051)',
            installationInstructions: cw051Content.installationInstructions
          },
        },
      },
      otis: {
        name: 'Otis',
        theme: otisTheme,
        devices: {
          'MOBELL-1080NB01': {
            name: 'Knok (MOBELL-1080NB01)',
            installationInstructions: knokContent.installationInstructions
          },
          'MOCAM-SIG02': {
            name: 'Cori (MOCAM-SIG02)',
            installationInstructions: coriContent.installationInstructions
          },
          'PTO-01': {
            name: 'PowerTech Outlet (PTO-01)',
            installationInstructions: pepOutletContent.installationInstructions
          },
          'PTP-01': {
            name: 'PowerTech Plug (PTP-01)',
            installationInstructions: pepPlugContent.installationInstructions
          },
          'PTS-01': {
            name: 'PowerTech Switch (PTS-01)',
            installationInstructions: pepSwitchContent.installationInstructions
          },
          'SPRCAM': {
            name: 'View (SPRCAM)',
            installationInstructions: viewContent.installationInstructions
          },
        }
      },
      visi: {
        name: 'Visi',
        theme: visiTheme,
        devices: {
          'PEC-33': {
            name: 'Leedarson Indoor Smart Camera (PEC-33)',
            installationInstructions: pecCamContent.installationInstructions
          },
        }
      },
      notion: {
        name: 'Notion',
        theme: notionTheme,
        devices: {
          'PEC-33': {
            name: 'Notion Indoor Smart Camera (PEC-33)',
            installationInstructions: pecCamContent.installationInstructions
          },
          'SPRCAM': {
            name: 'View (SPRCAM)',
            installationInstructions: viewContent.installationInstructions
          },
          'PEH-33': {
            name: 'Notion Camera (PEH-33)',
            installationInstructions: pehCamContent.installationInstructions
          },
          'N102': {
            name: 'Notion Doorbell (N102)',
            installationInstructions: n102Content.installationInstructions
          },
          'A685': {
            name: 'Notion Chime (A685)',
            installationInstructions: a685Content.installationInstructions
          },

        }
      },
      geeni: {
        name: 'Geeni',
        theme: geeniTheme,
        devices: {
          'P161': {
            name: 'Whale Indoor Smart Camera (P161)',
            installationInstructions: p161Content.installationInstructions
          },
          'P159': {
            name: 'Whale Indoor Smart Camera (P159)',
            installationInstructions: p159Content.installationInstructions
          },
          'P158': {
            name: 'Whale Indoor Smart Camera (P158)',
            installationInstructions: p158Content.installationInstructions
          },
          'MI-CW051-999W': {
            name: 'Whale Indoor Smart Camera (CW051)',
            installationInstructions: cw051Content.installationInstructions
          },
          'MI-EW020-999W': {
            name: 'Smart LED Strip (EW020)',
            installationInstructions: ew020Content.installationInstructions
          }
        },
        categories: {
          air_purifier: {
            name: 'air_purifier',
            installationInstructions: airPurifierCategoryContent.installationInstructions
          },
          appliance: {
            name: 'appliance',
            installationInstructions: applianceCategoryContent.installationInstructions
          },
          bulb: {
            name: 'bulb',
            installationInstructions: bulbCategoryContent.installationInstructions
          },
          camera: {
            name: 'camera',
            installationInstructions: cameraCategoryContent.installationInstructions
          },
          doorbell: {
            name: 'doorbell',
            installationInstructions: doorbellCategoryContent.installationInstructions
          },
          floodlight: {
            name: 'floodlight',
            installationInstructions: floodlightCategoryContent.installationInstructions
          },
          garage_door: {
            name: 'garage_door',
            installationInstructions: garageCategoryContent.installationInstructions
          },
          garage_door_controller: {
            name: 'garage_door_controller',
            installationInstructions: garageCategoryContent.installationInstructions
          },
          humidifier: {
            name: 'humidifier',
            installationInstructions: humidifierCategoryContent.installationInstructions
          },
          light: {
            name: 'light',
            installationInstructions: lightCategoryContent.installationInstructions
          },
          light_strip: {
            name: 'light_strip',
            installationInstructions: lightStripCategoryContent.installationInstructions
          },
          pet: {
            name: 'pet',
            installationInstructions: petCategoryContent.installationInstructions
          },
          pet_camera: {
            name: 'pet_camera',
            installationInstructions: petCameraCategoryContent.installationInstructions
          },
          pet_feeder: {
            name: 'pet_feeder',
            installationInstructions: petFeederCategoryContent.installationInstructions
          },
          plug: {
            name: 'plug',
            installationInstructions: plugCategoryContent.installationInstructions
          },
          power_strip: {
            name: 'power_strip',
            installationInstructions: powerStripCategoryContent.installationInstructions
          },
          switch: {
            name: 'switch',
            installationInstructions: switchCategoryContent.installationInstructions
          },
          sensor: {
            name: 'sensor',
            installationInstructions: sensorCategoryContent.installationInstructions
          },
          smart_scale: {
            name: 'smart_scale',
            installationInstructions: smartScaleCategoryContent.installationInstructions
          },
          thermostat: {
            name: 'thermostat',
            installationInstructions: thermostatCategoryContent.installationInstructions
          },
        }
      },
    },
  },
  mutations: {},
  actions: {}
});
